export function qtInit() {
    window.console.log("QT-init");
    //集成应用的appKey
    window.aplus_queue.push({
      action: "aplus.setMetaInfo",
      arguments: ["appKey", process.env.VUE_APP_QT_APPKEY],
    });
    //如果是私有云部署还需要在上面那段JS后面紧接着添加日志域名埋点
    //通常私有云日志服务端域名类似于：quickaplus-web-api.xxx.com.cn, 具体域名要找交付同学要
    window.aplus_queue.push({
      action: "aplus.setMetaInfo",
      arguments: ["aplus-rhost-v", process.env.VUE_APP_QT_URL],
    });
    if (process.env.NODE_ENV === "uat") {
      //开启调试模式
      window.aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: ["DEBUG", true]
      });
    }
    window.aplus_queue.push({
      action: "aplus.record",
      arguments: [
        "$$_user_profile",
        "OTHER",
        {
          // eslint-disable-next-line @typescript-eslint/camelcase
          phone_number: "",
          // eslint-disable-next-line @typescript-eslint/camelcase
          registered_channel: process.env.VUE_APP_QT_UNIONID,
        },
      ],
    });
    window.aplus_queue.push({
      action: "aplus.setMetaInfo",
      arguments: [
        "aplus-auto-exp",
        [
          {
            cssSelector: ".autoexp-list-index-0",
            logkey: "sllp_article_exp", // 埋点方案中对应的事件编码
            props: ["article_id", "title_type","article_name", "search_contents", "search_type", "current_category"], // 自动曝光会携带item的name字段
          },
          {
            cssSelector: ".autoexp-list-index-1",
            logkey: "selp_article_exp", // 埋点方案中对应的事件编码
            props: ["article_id", "title_type","article_name", "search_contents", "search_type", "current_category"], // 自动曝光会携带item的name字段
          },
        ],
      ],
    });
}

export function aplusSendPV(trackData: any) {
    window.aplus_queue.push({
    action: "aplus.sendPV",
    arguments: [
      {
        // eslint-disable-next-line @typescript-eslint/camelcase
        is_auto: false,
      },
      {
        // eslint-disable-next-line @typescript-eslint/camelcase
        page_name: trackData.page_name,
        // eslint-disable-next-line @typescript-eslint/camelcase
        search_contents: trackData.search_contents || '',
        // eslint-disable-next-line @typescript-eslint/camelcase
        search_type: trackData.search_type || '',
        // eslint-disable-next-line @typescript-eslint/camelcase
        current_category: trackData.current_category || ''
      },
    ],
  });
}

export function aplusButtonClick(trackData: any) {
    window.aplus_queue.push({
        action: "aplus.record",
        arguments: [
          trackData.event_name,
          "CLK",
          {
            // eslint-disable-next-line @typescript-eslint/camelcase
            button_name: trackData.button_name,
            // eslint-disable-next-line @typescript-eslint/camelcase
            search_contents: trackData.search_contents || '',
            // eslint-disable-next-line @typescript-eslint/camelcase
            search_type: trackData.search_type || '',
            // eslint-disable-next-line @typescript-eslint/camelcase
            current_category: trackData.current_category || ''
          },
        ],
      });
}

export function aplusArticleButtonClick(trackData: any) {
    window.aplus_queue.push({
        action: "aplus.record",
        arguments: [
          trackData.event_name,
          "CLK",
          {
            // eslint-disable-next-line @typescript-eslint/camelcase
            article_id: trackData.article_id,
            // eslint-disable-next-line @typescript-eslint/camelcase
            title_type: trackData.title_type,
            // eslint-disable-next-line @typescript-eslint/camelcase
            article_name: trackData.article_name,
            // eslint-disable-next-line @typescript-eslint/camelcase
            search_contents: trackData.search_contents || '',
            // eslint-disable-next-line @typescript-eslint/camelcase
            search_type: trackData.search_type || '',
            // eslint-disable-next-line @typescript-eslint/camelcase
            current_category: trackData.current_category || ''
          },
        ],
      });
}

export function aplusAdClick(trackData: any) {
    window.aplus_queue.push({
        action: "aplus.record",
        arguments: [
          trackData.event_name,
          "CLK",
          {
            // eslint-disable-next-line @typescript-eslint/camelcase
            adspace_rank_id: trackData.adspace_rank_id,
            // eslint-disable-next-line @typescript-eslint/camelcase
            adspace_name:trackData.adspace_name
          },
        ],
      });
    }
export function aplusExp(trackData: any) {
    window.aplus_queue.push({
        action: "aplus.record",
        arguments: [
          trackData.event_name,
          "EXP",
          {
            // eslint-disable-next-line @typescript-eslint/camelcase
            adspace_rank_id: trackData.adspace_rank_id,
            // eslint-disable-next-line @typescript-eslint/camelcase
            adspace_name: trackData.adspace_name,
          },
        ],
      });
}

export function aplusGlobalProperty(trackData: any) {
    window.aplus_queue.push({
        action: "aplus.setMetaInfo",
        arguments: [
          "globalproperty",
          {
            // eslint-disable-next-line @typescript-eslint/camelcase
            belong_apply: trackData.belong_apply,
            // eslint-disable-next-line @typescript-eslint/camelcase
            referer_page_name: trackData.referer_page_name,
            // eslint-disable-next-line @typescript-eslint/camelcase
            current_page_name: trackData.current_page_name,
          },
        ],
      });
}

export function aplusVideoClick(trackData: any) {
    window.aplus_queue.push({
        action: "aplus.record",
        arguments: [
            trackData.event_name,
            "CLK",
            {
                // // eslint-disable-next-line @typescript-eslint/camelcase
                // video_name: trackData.video_name,
                // // eslint-disable-next-line @typescript-eslint/camelcase
                // is_watch_end: trackData.is_watch_end,
                // // eslint-disable-next-line @typescript-eslint/camelcase
              // video_rate: trackData.video_rate,
              ...trackData
            },
        ],
    });
}
export function isNull(str: string) {
    return typeof  str === 'undefined' || str === null || str === "";
}